import Image from "next/image";
// CMS-supplied hrefs are emitted verbatim - do NOT swap this for @repo/ui/navigation.
// The CMS localizes its own URLs (e.g. "cl/es/centro-de-ayuda/") and also returns
// external/relative ones, so prefixing here would double or corrupt the locale.
import Link from "next/link";

import type { Destination } from "@repo/ui/types/cms/common";

interface NationalDestinationsProps {
  destination: Destination;
}

export function NationalDestinations({ destination }: Readonly<NationalDestinationsProps>) {
  const { title, country_group, image } = destination;
  return (
    <>
      <div className="text-center" data-testid="national-destinations-header-section">
        {title && (
          <h3 className="mb-3 text-xl font-semibold" data-testid="national-destinations-title-lbl">
            {title}
          </h3>
        )}
        {image && (
          <Image
            src={image}
            alt={title || "Mapa de Chile"}
            width={160}
            height={240}
            className="mb-4"
            data-testid="national-destinations-image"
          />
        )}
      </div>
      <div className="mt-8" data-testid="national-destinations-countries-section">
        {country_group?.map((group) => (
          <ul key={group.country_name} data-testid="national-destinations-country-group-list">
            <li
              key={group.country_name}
              className="list-disc font-semibold"
              data-testid="national-destinations-country-name-lbl"
            >
              {group.country_name}
              <ul
                className="columns-2 gap-x-8 text-sm font-light"
                data-testid="national-destinations-city-list"
              >
                {group.citites.map((city) => (
                  <li key={city.text} data-testid="national-destinations-city-item">
                    <Link href={city.url} data-testid="national-destinations-city-link">
                      {city.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        ))}
      </div>
    </>
  );
}
